import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import ReactTooltip from "react-tooltip";
import FadeLoader from "react-spinners/FadeLoader";
import { connect } from 'react-redux';
import { css } from "@emotion/core";
const override = css`
  display: block;
  top: 50%;
  margin: 0 auto;
  border-color: red;
`;

function formatDate(date) {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`; // ← Correct format for <input type="date">
}

function formatDateTime(dateStr) {
  const date = new Date(dateStr);
  const pad = (n) => (n < 10 ? '0' + n : n);

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // Months start at 0
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}

class MonthlyRetailerOrderSummary extends Component {
  constructor(props) {
    super(props);

    const today = new Date();

    // Start Date: 1st of current month, 2 years ago
    const startDate = new Date(today.getFullYear() - 2, today.getMonth(), 1);

    // End Date: last day of previous month
    const endDate = new Date(today.getFullYear(), today.getMonth(), 0);

    this.state = {
      loading: false,
      salesmanList: [],
      selectedsalesmanList: [],
      reportList: [],
      orgreportList: [],
      vdSalesmanCode: '',
      orderObj: '',
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      smanCode: '',
      todaydate: formatDate(startDate),
      httpURL: this.props.httpURL,
      loginuserObj: this.props.userObj,
      distributorCode: this.props.userObj,
      salesmanCode: this.props.userObj.salesmanCode,
      companyCode: this.props.userObj.companyCode,
      userType: this.props.userObj.userType,
      loginSalesmanCode: this.props.userObj.salesmanCode,
      vdFState: '',
      vdFStateList: [],
      fileUrl: '',
      currentPage: 1,
      pageSize: 100,  // Load 100 records per page
      filteredData:[],
      filterType: 'default',
    };
  }

  componentDidMount() {
      this.fetchReportLog(); // ✅ triggers on page render
  }

  // Fetch the report data
  reportGo = () => {
    let dFlag = true;
    let stateVal = '';
    const { filterType, startDate, endDate } = this.state;
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (filterType === 'default' && diffDays > 30) {
        alert('For Default Search, the date range cannot exceed 30 days.');
        return;
    }

     if (filterType === 'download' && diffDays > 60) {
        alert('For Download Report, the date range cannot exceed 60 days.');
        return;
    }
      
    if (start > end) {
        alert('Start Date cannot be after End Date.');
        return;
    }

    if (this.state.vdFState === '' || this.state.vdFState === undefined) {
      stateVal = "All";
    } else {
      stateVal = this.state.vdFState;
    }

    if (dFlag) {
      let tempSalesmanCode = this.state.vdSalesmanCode;
      if (tempSalesmanCode === "" || tempSalesmanCode === null || tempSalesmanCode === undefined) {
        tempSalesmanCode = "All";
      }

      const params = {
        salesmanCode: tempSalesmanCode,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        loginSalesmanCode: this.state.loginSalesmanCode,
        companyCode: this.state.companyCode,
        state: stateVal,
        filterType: filterType,
      };

      this.setState({ loading: true });

      axios.get(this.state.httpURL + "/report/getMonthlyRetailerOrderSummary", { params })
        .then(response => response.data)
        .then((data) => {
          if (data.valid) {
            this.setState({
              loading: false,
              reportList: data.baSalesReportList,
              filteredData: data.baSalesReportList,
            });
           // If filterType is 'download' and a valid file URL exists
            if (filterType === 'download' && data.fileUrl) {
              const fileURL = data.fileUrl;  // Example: http://localhost:8080/baSalesReports/Monthly_Retailer_Order_Summary_1735621159393.xlsx
              console.log('fileURL > ', fileURL);

              // Create the popup content with a download link
              const popupContent = `
                  <div style="text-align: center;">
                      <h3 style="margin-bottom: 10px;">Your file is ready for download!</h3>
                      <p style="margin-bottom: 20px;">Click below to download the file:</p>
                      <a href="${fileURL}" target="_blank" style="color: #007bff; text-decoration: none; font-size: 18px; font-weight: bold;">
                          Download
                      </a>
                      <div>
                          <button id="closePopup" style="margin-top: 20px; padding: 10px 20px; background-color: #f44336; color: white; border: none; border-radius: 5px; cursor: pointer;">
                              Close
                          </button>
                      </div>
                  </div>
              `;

              // Create the popup container (modal)
              const modal = document.createElement('div');
              modal.style.position = 'fixed';
              modal.style.top = '0';
              modal.style.left = '0';
              modal.style.width = '100%';
              modal.style.height = '100%';
              modal.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
              modal.style.display = 'flex';
              modal.style.justifyContent = 'center';
              modal.style.alignItems = 'center';
              modal.style.zIndex = '9999';

              // Modal inner content
              const modalContent = document.createElement('div');
              modalContent.style.backgroundColor = 'white';
              modalContent.style.padding = '20px';
              modalContent.style.borderRadius = '10px';
              modalContent.style.maxWidth = '500px';
              modalContent.style.width = '80%';
              modalContent.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
              modalContent.innerHTML = popupContent;

              // Append content to the modal
              modal.appendChild(modalContent);

              // Append the modal to the body
              document.body.appendChild(modal);

              // Close the modal when the user clicks the close button
              document.getElementById('closePopup').addEventListener('click', () => {
                  document.body.removeChild(modal);
              });

              console.log('Download link popup shown for file: ', fileURL);
            }
            ReactTooltip.rebuild();
          } else {
            alert(data.responseMsg);
          }
        }).catch(err => {
          this.setState({ loading: false });
          alert(err);
        });
    }
  }


  fetchReportLog = () => {
    const { startDate, endDate } = this.state;

    if (!startDate || !endDate) {
      alert('Please select both Start Date and End Date.');
      return;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start > end) {
      alert('Start Date cannot be after End Date.');
      return;
    }

    this.setState({ loading: true });

    const params = { startDate, endDate };

    axios.get(this.state.httpURL + "/report/getMonthlyRetailerOrderSummary", { params })
      .then(response => response.data)
      .then((data) => {
        console.log('data > ',data)
        if (data.valid) {
          this.setState({
            loading: false,
            reportList: data.reportList,
            filteredData: data.reportList,
          });
        } else {
          this.setState({ loading: false });
          alert(data.responseMsg);
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        alert('Error fetching report: ' + err.message);
      });
  };


  handleFilterChange = (event) => {
    this.setState({ filterType: event.target.value });
  };

  // Handle form input change
  reportChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  // Pagination control to go to the previous page
  goToPreviousPage = () => {
    if (this.state.currentPage > 1) {
      this.setState((prevState) => ({ currentPage: prevState.currentPage - 1 }));
    }
  };

  // Pagination control to go to the next page
  goToNextPage = () => {
    const maxPage = Math.ceil(this.state.filteredData?.length / this.state.pageSize);
    if (this.state.currentPage < maxPage) {
      this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }));
    }
  };

  handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    const filteredData = this.state.reportList.filter((report) => {
      return Object.values(report).some((value) =>
        String(value).toLowerCase().includes(searchValue)
      );
    });
    this.setState({ filteredData });
  };

  // Render the component
  render() {
    const startIndex = (this.state.currentPage - 1) * this.state.pageSize;
    const endIndex = startIndex + this.state.pageSize;
    const currentPageData = this.state.filteredData?.slice(startIndex, endIndex);

    return (
      <div className="O2Container_Wrapper" >
        <ReactTooltip />
        <div className="O2Container_Table">
          <div className="O2Table_Header">
            Monthly Retailer Order Summary
          </div>
          <div className="O2Table_Body">
            <div className="O2Table_SubContainer Report_subContainer" style={{ marginBottom: '20px' }}>
                {/* <div className="O2Content_row" style={{ marginBottom: '10px' }}>
                    <div className="O2Content_row">
                    <div className="O2Content_orderTypeRadio">
                        <span>
                        <input
                            type="radio"
                            value="default"
                            name="filterType"
                            checked={this.state.filterType === 'default'}
                            onChange={this.handleFilterChange}
                        />
                        Default Search
                        </span>
                        <span>
                        <input
                            type="radio"
                            value="download"
                            name="filterType"
                            checked={this.state.filterType === 'download'}
                            onChange={this.handleFilterChange}
                        />
                        Download Report
                        </span>
                    </div>
                    </div>
                </div> */}

                <div className="O2Content_row" style={{ marginBottom: '10px' }}>
                    <div className="contentRow_Label" style={{ fontSize: '16px', marginRight: '10px' }}>Date From</div>
                    <div className="contentRow_Value">
                    <input
                        type="date"
                        name="startDate"
                        value={this.state.startDate}
                        onChange={this.reportChange}
                        style={{ padding: '5px', fontSize: '16px' }}
                        disabled
                    />
                    </div>
                </div>
                <div className="O2Content_row" style={{ marginBottom: '10px' }}>
                    <div className="contentRow_Label" style={{ fontSize: '16px', marginRight: '10px' }}>Date To</div>
                    <div className="contentRow_Value">
                    <input
                        type="date"
                        name="endDate"
                        value={this.state.endDate}
                        onChange={this.reportChange}
                        style={{ padding: '5px', fontSize: '16px' }}
                        disabled
                    />
                    </div>
                </div>
                
                {/* <div className="O2Table_Go" onClick={this.reportGo}>
                    <button
                    disabled={this.state.loading}
                    style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                    >
                      {this.state.loading ? 'Processing...' : 'Go'}
                    </button>
                </div> */}
                </div>
            <div className="searchWrapper">
                <input
                type="text"
                className="tableMultiFilterSearch_input"
                placeholder="Search..."
                onChange={this.handleSearch}
                />
            </div>
            {/* <div className="Table_wrapper visitDetailTable_Wrapper" >
              <table className="customTable UsageDetailReportTable">
                <thead>
                  <tr>
                    <th>Retailer Verification</th>
                    <th>Salesman Code</th>
                    <th>Username</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Product Code</th>
                    <th>Product Name</th>
                    <th>Order Quantity</th>
                    <th>Order Value</th>
                    <th>Month-Year</th>
                    <th>SKU Code</th>
                    <th>Order Type</th>
                    <th>Team Tag</th>
                    <th>Classification</th>
                    <th>Subcategory</th>
                    <th>Brand</th>
                    <th>Retailer Code</th>
                    <th>Old Retailer Code</th>
                    <th>Retailer Name</th>
                  </tr>
                </thead>
                <tbody>
                  {!currentPageData || currentPageData?.length === 0 ? (
                    <tr align="center">
                      <td colSpan="19">No Records</td>
                    </tr>
                  ) : (
                    currentPageData.map((report, index) => (
                      <tr key={index}>
                        <td>{report.retailer_verfication}</td>
                        <td>{report.salesman_code}</td>
                        <td>{report.username}</td>
                        <td>{report.state}</td>
                        <td>{report.city}</td>
                        <td>{report.productCode}</td>
                        <td>{report.productName}</td>
                        <td>{report.orderQty}</td>
                        <td>{report.orderValue}</td>
                        <td>{report.YYYMM}</td>
                        <td>{report.skuCode}</td>
                        <td>{report.orderType}</td>
                        <td>{report.teamTag}</td>
                        <td>{report.classification}</td>
                        <td>{report.subcategory}</td>
                        <td>{report.brand}</td>
                        <td>{report.retailer_code}</td>
                        <td>{report.old_retailer_code}</td>
                        <td>{report.rtname}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div> */}

            <div className="Table_wrapper salesReportLogTable_Wrapper">
              <table className="customTable SalesReportLogTable">
                <thead>
                  <tr>
                    {/* <th>ID</th> */}
                    <th style={{ width: "30%" }}>Report Name</th>
                    <th>From Date</th>
                    <th>To Date</th>
                    <th>Error Message</th>
                    <th>Created At</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {!currentPageData || currentPageData.length === 0 ? (
                    <tr align="center">
                      <td colSpan="8">No Records</td>
                    </tr>
                  ) : (
                    currentPageData.map((log, index) => (
                      <tr key={index}>
                        {/* <td>{log.id}</td> */}
                        <td style={{ width: "30%" }}>{log.filePath}</td>
                        <td>{log.fromDate}</td>
                        <td>{log.toDate}</td>
                        <td>{log.errorMessage || ''}</td>
                        <td>{formatDateTime(log.createdAt)}</td>
                        <td>{log.status}</td>
                        <td>
                          {log.filePath ? (
                            <a
                              href={`http://139.59.8.226/baSalesReports/${log.filePath}`}
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#007bff", textDecoration: "underline" }}
                            >
                              Download
                            </a>
                          ) : (
                            "N/A"
                          )}
                      </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>


            {/* Pagination Controls */}
            <div className="O2Table_bottomSubContainer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="O2Table_PageCount" style={{ fontSize: '16px' }}>
                <span>
                  Showing {currentPageData?.length} of {this.state.filteredData?.length} entries
                </span>
              </div>
              <div className="O2Table_Pagination" style={{ display: 'flex', alignItems: 'center' }}>
                <button className="pagination-button" disabled={this.state.currentPage === 1} onClick={this.goToPreviousPage} style={{ padding: '8px 12px', backgroundColor: '#007bff', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: '5px', marginRight: '10px' }}>
                  Previous
                </button>
                <span className="pagination-text" style={{ fontSize: '16px' }}>Page {this.state.currentPage}</span>
                <button className="pagination-button" disabled={this.state.filteredData?.length <= this.state.currentPage * this.state.pageSize} onClick={this.goToNextPage} style={{ padding: '8px 12px', backgroundColor: '#007bff', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: '5px', marginLeft: '10px' }}>
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Loading Spinner */}
        <FadeLoader css={override} size={150} color={"#123abc"} loading={this.state.loading} />
      </div>
    );
  }
}

// Redux connection
const mapStateToProps = state => {
  return {
    userObj: state.userObj,
    httpURL: state.httpURL,
  };
};

export default connect(mapStateToProps)(MonthlyRetailerOrderSummary);
